
import { Link, useLocation } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { useState } from 'react';
import { CSVLink  } from "react-csv";

const FilterComponent = (props) => {
	
	
	let  [state, setStateData] = useState({
		filter: {
			status: "new",
			type: "all",
			cluster: "all",
			date: {
				startDate: null,
				endDate: null
			}
		},
		exportData: [],
		callback: null
	})
	
	let dateRangeRef = null;
	const {dateFrom, dateTo, filter, value, clusters, exportData, getActions, getActionsCsv} = {...props}

	const applyFilterDate = (e, picker) => {
		let { filter } = { ...state };
		filter.date.startDate = picker.startDate.format('MM/DD/YYYY');
		filter.date.endDate = picker.endDate.format('MM/DD/YYYY');

		picker.element.val(
			picker.startDate.format('MM/DD/YYYY') +
			' - ' +
			picker.endDate.format('MM/DD/YYYY')
		);

		state.filter = filter;
		state.callback = getActions(e, 'filter', filter);
		setStateData({...state, state})

		
		
	}


	const cancelFilterDate = (e, picker) => {
		let { filter } = { ...state };
		filter.date.startDate = null;
		filter.date.endDate = null;
		picker.element.val("");
		
		state.filter = filter;
		state.callback = getActions(e, 'filter', filter);
		setStateData({...state, state})
	}

	const updateFilterHander = (e) => {
		let { filter } = { ...state };
		filter[e.target.name] = e.target.value;
		state.filter = filter;
		state.callback = getActions(e, 'filter', filter);
		setStateData({ ...state, state });
	}


	

	

	

	return (

		<>
			<div className="card">
				<div className="card-body">
					{/* <h5 className="card-title">Filter</h5> */}
					<form className='form'>
						<div className='row'>



							<div className='col-12 mt-3'>
								<label>Date</label>
								<DateRangePicker
									ref={dateRangeRef}
									initialSettings={{
										autoUpdateInput: false,
										startDate: dateFrom,
										endDate: dateTo,
										locale: {
											cancelLabel: 'Clear',
										},
									}}
									onApply={applyFilterDate}
									onCancel={cancelFilterDate}
								>
									<input type="text" className="form-control" value={value} />
								</DateRangePicker>
							</div>
							<div className='col-12 mt-3'>
								<label>Cluster</label>
								<select
									name="cluster"
									className="form-select"
									value={filter.cluster}
									onChange={e => updateFilterHander(e)}
								>
									<option value="all">All</option>
									{clusters.length > 0 &&

										clusters.map(cluster => {
											return <option key={cluster._id} value={cluster.name}>{cluster.name}</option>
										})
									}
								</select>
							</div>
							<div className='col-12 mt-3'>
								<label>Status</label>
								<select
									name="status"
									className="form-select"
									value={filter.status}
									onChange={e => updateFilterHander(e)}
								>
									<option value="all">All</option>
									<option value="new">New</option>
									<option value="worked in progress">Worked In Progress</option>
									<option value="additional information required">Additional Information Required</option>
									<option value="resolved">Resolved</option>
								</select>
							</div>
						</div>
					</form>
					<div className="d-grid gap-2 mx-auto">
						<button className="btn btn-primary" type="button" onClick={e => getActions(e, 'filterHandler')}>Submit</button>
						
						<CSVLink
							filename='CheerExport.csv'
							data={exportData}
							asyncOnClick={true}
							onClick={getActionsCsv}
							className="btn btn-secondary"
							target="_blank"
						>Download to CSV</CSVLink>
						
					</div>
				</div>
			</div>
		</>
	)

}

export default withOktaAuth(FilterComponent);